import { match } from 'ts-pattern'

import { Office } from '~/models/types'

import { DrawerContent, drawerContent, DrawerPosition } from './types'

type State = {
  isOpenDrawer: boolean
  isOpenInfoWindow: boolean
  clickedPin: Office | null
  currentDrawerPosition: DrawerPosition
  currentDrawerContent: DrawerContent
  prevDrawerContent: DrawerContent
}

type OpenAction = {
  type: 'OPEN'
}

type CloseAction = {
  type: 'CLOSE'
}

type OpenInfoWindowAction = {
  type: 'OPEN_INFO_WINDOW'
  payload: Office
}

type CloseInfoWindowAction = {
  type: 'CLOSE_INFO_WINDOW'
}

type SetDrawerPositionAction = {
  type: 'SET_DRAWER_POSITION'
  payload: DrawerPosition
}

type SetDrawerContentAction = {
  type: 'SET_DRAWER_CONTENT'
  payload: DrawerContent
}

type OnClickOfficeCardAction = {
  type: 'ON_CLICK_OFFICE_CARD'
  payload: Office
}

type OnOpenSearchFormAction = {
  type: 'ON_OPEN_SEARCH_FORM'
}

type OnCloseSearchFormAction = {
  type: 'ON_CLOSE_SEARCH_FORM'
}

type OnClickGoToListAction = {
  type: 'ON_CLICK_GO_TO_LIST'
}

type Action =
  | OpenAction
  | CloseAction
  | OpenInfoWindowAction
  | CloseInfoWindowAction
  | SetDrawerPositionAction
  | SetDrawerContentAction
  | OnClickOfficeCardAction
  | OnOpenSearchFormAction
  | OnCloseSearchFormAction
  | OnClickGoToListAction
export const mapReducer = (state: State, action: Action): State => {
  return match(action)
    .with({ type: 'OPEN' }, () => ({
      ...state,
      isOpenDrawer: true,
    }))
    .with({ type: 'CLOSE' }, () => ({
      ...state,
      isOpenDrawer: false,
    }))
    .with({ type: 'OPEN_INFO_WINDOW' }, (action) => ({
      ...state,
      clickedPin: action.payload,
      isOpenInfoWindow: true,
    }))
    .with({ type: 'CLOSE_INFO_WINDOW' }, () => ({
      ...state,
      clickedPin: null,
      isOpenInfoWindow: false,
      currentDrawerContent: drawerContent.list,
    }))
    .with({ type: 'SET_DRAWER_POSITION' }, (action) => {
      return {
        ...state,
        currentDrawerPosition: action.payload,
      }
    })
    .with({ type: 'SET_DRAWER_CONTENT' }, (action) => {
      return {
        ...state,
        currentDrawerContent: action.payload,
      }
    })
    .with({ type: 'ON_CLICK_OFFICE_CARD' }, (action) => {
      return {
        ...state,
        clickedPin: action.payload,
        currentDrawerContent: drawerContent.detail,
        isOpenDrawer: true,
      }
    })
    .with({ type: 'ON_OPEN_SEARCH_FORM' }, () => {
      return {
        ...state,
        prevDrawerContent: state.currentDrawerContent,
        currentDrawerContent: drawerContent.searchForm,
        isOpenDrawer: true,
      }
    })
    .with({ type: 'ON_CLOSE_SEARCH_FORM' }, () => {
      return {
        ...state,
        currentDrawerContent: state.prevDrawerContent,
        isOpenDrawer: true,
      }
    })
    .with({ type: 'ON_CLICK_GO_TO_LIST' }, () => {
      return {
        ...state,
        currentDrawerContent: drawerContent.list,
        isOpenDrawer: true,
        clickedPin: null,
      }
    })
    .otherwise(() => state)
}
